export const errorCode = new Map();
// Business
errorCode.set("IAD", "Invalid ADs");
errorCode.set("CDNS", "CDN SWITCHING");
errorCode.set("BLC", "BUFFERING LIMIT");
errorCode.set("NCC", "NO CONNECTION");
errorCode.set("MCS", "MAIN CONTENT STALLED");
errorCode.set("ASC", "AD STALLED");
errorCode.set("EDD", "EXTERNAL DISPLAY DETECTED");
errorCode.set("BMC", "BOOKMARKING");
errorCode.set("OEC", "OVP ERROR");
errorCode.set("DAC", "DRM ACTIVATION");
errorCode.set("PEB", "PLAYBACK EVENT BOUNDARY_ERROR");
// Player Errors
errorCode.set("IPE", "INTERNAL PLAYER ERROR");
errorCode.set("UPE", "UNKNOWN PLAYER ERROR CODE");
errorCode.set("XPP", "org.xmlpull.v1.XmlPullParserException");
errorCode.set("ASI", "audio.AudioSink.InitializationException");
errorCode.set("AMCO", "android.media.MediaCodec.CodecException");
errorCode.set("AMCR", "android.media.MediaCodec.CryptoException");
errorCode.set("AMD", "android.media.MediaDrmException");
errorCode.set("ARB", "android.media.ResourceBusyException");
errorCode.set("ANP", "android.media.NotProvisionedException");
errorCode.set("JNP", "java.lang.NullPointerException");
errorCode.set("JIAC", "java.lang.IllegalAccessError");
errorCode.set("JIS", "java.lang.IllegalStateException");
errorCode.set("JEOF", "java.io.EOFException");
errorCode.set("JAOB", "java.lang.ArrayIndexOutOfBoundsException");
errorCode.set("JIAR", "java.lang.IllegalArgumentException");
errorCode.set("EDS", "com.google.android.exoplayer2.drm.DrmSession.DrmSessionException");
errorCode.set("EHDS", "com.google.android.exoplayer2.upstream.HttpDataSource.HttpDataSourceException");
errorCode.set("EDI", "com.google.android.exoplayer2.mediacodec.MediaCodecRenderer.DecoderInitializationException");
errorCode.set("EIRC", "com.google.android.exoplayer2.upstream.HttpDataSource.InvalidResponseCodeException");
errorCode.set("EULE", "com.google.android.exoplayer2.upstream.Loader.UnexpectedLoaderException");
errorCode.set("EPEC", "com.google.android.exoplayer2.ParserException");
errorCode.set("EASW", "com.google.android.exoplayer2.audio.AudioSink.WriteException");
errorCode.set("EDMS", "com.google.android.exoplayer2.source.dash.DashManifestStaleException");
errorCode.set("ESDE", "com.google.android.exoplayer2.text.SubtitleDecoderException");
errorCode.set("EESTG", "com.google.android.exoplayer2.util.EGLSurfaceTexture.GlException");
errorCode.set("EMCVD", "com.google.android.exoplayer2.video.MediaCodecVideoDecoderException");
errorCode.set("ETE", "com.google.android.exoplayer2.ExoTimeoutException");
errorCode.set("EMCD", "com.google.android.exoplayer2.mediacodec.MediaCodecDecoderException");

export const sessionStateCode = new Map();
sessionStateCode.set("0", "OVP");
sessionStateCode.set("1", "VAM");
sessionStateCode.set("2", "YoSpace");
sessionStateCode.set("3", "Freewheel");
sessionStateCode.set("4", "Player Engine Item");
sessionStateCode.set("5", "Media Tailor");

export const playerStateCode = new Map();
playerStateCode.set("0", "Null");
playerStateCode.set("1", "Loading");
playerStateCode.set("2", "Playing");
playerStateCode.set("3", "Paused");
playerStateCode.set("4", "Seeking");
playerStateCode.set("5", "Buffering");
playerStateCode.set("6", "Stopped");
playerStateCode.set("7", "Finished");

export const adStateCode = new Map();
adStateCode.set("0", "Main Content");
adStateCode.set("1", "Advert");
adStateCode.set("2", "Imminent Ad Break Start")
adStateCode.set("3", "Recent Ad Break End")
